var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCtIndividual = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 25,
  viewBox: "0 0 21 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0531 11.9453C10.7196 11.9453 11.3589 11.6292 11.8302 11.0666C12.3016 10.504 12.5664 9.74096 12.5664 8.94531C12.5664 8.14966 12.3016 7.3866 11.8302 6.82399C11.3589 6.26138 10.7196 5.94531 10.0531 5.94531C9.38651 5.94531 8.74724 6.26138 8.27591 6.82399C7.80457 7.3866 7.53978 8.14966 7.53978 8.94531C7.53978 9.74096 7.80457 10.504 8.27591 11.0666C8.74724 11.6292 9.38651 11.9453 10.0531 11.9453ZM4.18872 20.9453C4.18872 20.0261 4.34041 19.1158 4.63512 18.2665C4.92983 17.4172 5.36179 16.6456 5.90635 15.9956C6.45091 15.3456 7.09739 14.8299 7.80888 14.4782C8.52038 14.1264 9.28296 13.9453 10.0531 13.9453C10.8232 13.9453 11.5858 14.1264 12.2973 14.4782C13.0088 14.8299 13.6552 15.3456 14.1998 15.9956C14.7444 16.6456 15.1763 17.4172 15.471 18.2665C15.7657 19.1158 15.9174 20.0261 15.9174 20.9453H4.18872Z",
  fill: "#FB8C3D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCtIndividual);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ct-individual.b8c71cf51642bd94e90633b110af3b60.svg";